<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <mat-form-field class="full-width" appearance="outline" *ngIf="importResult === null">
            <mat-label>Select Branch <span class="required-star">*</span></mat-label>
            <input type="text" matInput [formControl]="branchCtrl" [matAutocomplete]="autoBranch" name="branch">
            <mat-autocomplete #autoBranch="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
                <mat-option [value]="">-- None --</mat-option>
                <mat-option *ngFor="let branch of filteredBranch | async" [value]="branch.Name">
                    {{branch.Name}}
                </mat-option>
            </mat-autocomplete>
            <button mat-icon-button matSuffix tabindex="-1">
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </mat-form-field>

        <div class="date-range-row" *ngIf="importResult === null">
            <mat-form-field appearance="outline" class="date-field">
                <mat-label>Date From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="dateFrom" readonly>
                <button *ngIf="dateFrom" matSuffix mat-icon-button (click)="dateFrom = null" tabindex="-1">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="date-field">
                <mat-label>Date To</mat-label>
                <input matInput [matDatepicker]="pickerTo" [(ngModel)]="dateTo" readonly>
                <button *ngIf="dateTo" matSuffix mat-icon-button (click)="dateTo = null" tabindex="-1">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="mb-3 btn-container" *ngIf="importResult === null">
            <label class="styled-upload-button machine" [class.disabled]="uploaded.machine"
                [class.disabled-btn]="uploaded.machine">
                (NGTeco) Select .dat File (Machine)
                <input type="file" accept=".dat" hidden [disabled]="uploaded.machine"
                    (change)="onFileSelected($event, 'machine')" />
            </label>

            <label class="styled-upload-button web" [class.disabled]="uploaded.web" [class.disabled-btn]="uploaded.web">
                (NGTeco) Select .dat File (Web)
                <input type="file" accept=".dat" hidden [disabled]="uploaded.web"
                    (change)="onFileSelected($event, 'web')" />
            </label>
        </div>

        <div class="mb-3 btn-container" *ngIf="importResult === null">
            <label class="styled-upload-button machine" [class.disabled]="uploaded.zkmachine"
                [class.disabled-btn]="uploaded.zkmachine">
                (ZKTeco) Select .dat File (Machine)
                <input type="file" accept=".dat" hidden [disabled]="uploaded.zkmachine"
                    (change)="onFileSelected($event, 'zkmachine')" />
            </label>
        </div>

        <!-- Result Message -->
        <div *ngIf="importResult" class="alert alert-info mt-3">
            <mat-icon class="me-1">info</mat-icon>
            <small>{{ importResult.message }}</small>
        </div>

        <!-- Error Message -->
        <div *ngIf="importError" class="alert alert-danger mt-3">
            <mat-icon class="me-1">error</mat-icon>
            <small>{{ importError }}</small>
        </div>

        <!-- File selected info -->
        <div *ngIf="!importResult && selectedFile" class="mt-2">
            <strong>Selected File:</strong> {{ selectedFile.name }}<br />
            <strong>Source:</strong> {{ selectedSource | titlecase }}
        </div>
    </div>

    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()" [disabled]="isLoading">
            {{ data.cancelText }}
        </button>

        <!-- Upload Button -->
        <ng-container *ngIf="!isLoading && selectedFile && selectedSource && importResult === null && !importError">
            <button mat-raised-button color="primary" (click)="uploadDatFile()" class="upload-confirm-button">
                Upload
            </button>
        </ng-container>

        <!-- Loading -->
        <ng-template [ngIf]="isLoading">
            <button mat-button class="upload-button" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Uploading...
            </button>
        </ng-template>
    </div>
</div>